// @ts-nocheck
import * as Types from '../../__generated__/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type PdfPrintModal_CheckoutConfigFragment = { __typename?: 'CheckoutConfig', id: string, additionalSitePriceInCents: number };

export type PrintModal_SaveAdditionalSitePriceMutationVariables = Types.Exact<{
  input: Types.SaveCheckoutConfigInput;
}>;


export type PrintModal_SaveAdditionalSitePriceMutation = { __typename?: 'Mutation', saveCheckoutConfig: { __typename?: 'SaveCheckoutConfigResult', checkoutConfig: { __typename?: 'CheckoutConfig', id: string, additionalSitePriceInCents: number } } };

export const PdfPrintModal_CheckoutConfigFragmentDoc = gql`
    fragment PDFPrintModal_CheckoutConfig on CheckoutConfig {
  id
  additionalSitePriceInCents
}
    `;
export const PrintModal_SaveAdditionalSitePriceDocument = gql`
    mutation PrintModal_SaveAdditionalSitePrice($input: SaveCheckoutConfigInput!) {
  saveCheckoutConfig(input: $input) {
    checkoutConfig {
      ...PDFPrintModal_CheckoutConfig
    }
  }
}
    ${PdfPrintModal_CheckoutConfigFragmentDoc}`;
export type PrintModal_SaveAdditionalSitePriceMutationFn = Apollo.MutationFunction<PrintModal_SaveAdditionalSitePriceMutation, PrintModal_SaveAdditionalSitePriceMutationVariables>;

/**
 * __usePrintModal_SaveAdditionalSitePriceMutation__
 *
 * To run a mutation, you first call `usePrintModal_SaveAdditionalSitePriceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrintModal_SaveAdditionalSitePriceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [printModalSaveAdditionalSitePriceMutation, { data, loading, error }] = usePrintModal_SaveAdditionalSitePriceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrintModal_SaveAdditionalSitePriceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<PrintModal_SaveAdditionalSitePriceMutation, PrintModal_SaveAdditionalSitePriceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<PrintModal_SaveAdditionalSitePriceMutation, PrintModal_SaveAdditionalSitePriceMutationVariables>(PrintModal_SaveAdditionalSitePriceDocument, options);
      }
export type PrintModal_SaveAdditionalSitePriceMutationHookResult = ReturnType<typeof usePrintModal_SaveAdditionalSitePriceMutation>;
export type PrintModal_SaveAdditionalSitePriceMutationResult = Apollo.MutationResult<PrintModal_SaveAdditionalSitePriceMutation>;
export type PrintModal_SaveAdditionalSitePriceMutationOptions = Apollo.BaseMutationOptions<PrintModal_SaveAdditionalSitePriceMutation, PrintModal_SaveAdditionalSitePriceMutationVariables>;